firebird.factory('videoConnectivityService', [
    '$window',
    '$timeout',
    'logService',
    'configService',
    'connectivityService',
    'avDeviceService',
    'phoneConferenceService',
    'analyticsWrapperService',
    'videoGlobalService',
    function (
        $window,
        $timeout,
        logService,
        configService,
        connectivityService,
        avDeviceService,
        phoneConferenceService,
        analyticsWrapperService,
        videoGlobalService
    ) {
        var service = {
            initialize: initialize
        };

        var self;

        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoConnectivityService');

        return service;

        function initialize(selfParam) {
            self = selfParam;

            self.initConnectivity = initConnectivity;

            // state for connectivity check with external service.
            // this data and code should be moved to connectivityService or elsewhere. It should also include some form of UDP test.
            self.checkConn = {
                timeout: 10000,
                timer: null,
                xhr1: null,
                status1: null,
                start1: 0,
                end1: 0,
                xhr2: null,
                status2: null,
                start2: 0,
                end2: 0,
                callbacks: [] // pending callbacks in checkConnectivity
            };

            self.checkConnectivity = checkConnectivity;
            self.stopCheckConnectivity = stopCheckConnectivity;
            self.logCheckConnectivityResult = logCheckConnectivityResult;

            // capture various times for metrics: call setup latency, disconnect duration, and others.
            self.connTimeData = {
                // following are boo unless indicated as time for timestamp

                enabled: false,

                appStart: $window._appStartTime || undefined, // time from app.js
                modInit: Date.now(), // time of this module init
                waitTime: undefined, // non-meeting page wait delays
                startTime: undefined, // will be either modInit, or appStart + non-meeting page wait delays.

                network: true, // assume connected initially
                nodeSocket: true, // assume connected initially
                mediaSocket: undefined,
                fsConnect: undefined,

                audioInput: true, // if false, then not used, e.g., switch to phone or disconnected device.
                voiceCallMedia: undefined,
                voiceCallConnect: undefined,
                voiceCallIce: undefined,

                videoButton: undefined, // button pressed
                videoStart: undefined, // time of last button press to on
                videoStop: undefined, // time of disconnect while the button is still on
                videoSetup: undefined, // time for video tx setup delay
                videoPublish: undefined,
                videoMedia: undefined,
                videoConnect: undefined,
                videoIce: undefined,

                screenButton: undefined,
                screenStart: undefined,
                screenStop: undefined,
                screenSetup: undefined,
                screenPublish: undefined,
                screenMedia: undefined,
                screenConnect: undefined,
                screenIce: undefined,

                connect: undefined, // time of last connect
                disconnect: undefined, // time of last disconnect
                count: undefined, // number of times reconnected
                reason: undefined, // node or media or comma separated.

                joinFlow: undefined, // wait time for join flow
                screenSelect: undefined, // wait time for screen share selection
                callSetup: undefined, // calculated time - call setup delay

                events: [], // each item is {type, ts}
                stats: null // pending stats data to send
            };

            self.updateConnTimeDevice = updateConnTimeDevice;
            self.updateConnTimeData = updateConnTimeData;
            self.addConnectivityMetric = addConnectivityMetric;
        }

        function initConnectivity() {
            const data = self.connTimeData;
            data.enabled = configService.getValue('connTimeData') === 'true';

            if (data.enabled) {
                data.events.push({ name: 'moduleInit', value: true, ts: data.modInit });
                if ($window._appStateChanges && $window._appStateChanges.length) {
                    const t0 = $window._appStateChanges[0].ts;
                    const t1 = $window._appStateChanges.find(
                        item => item.to && item.to.indexOf('meeting-active') > -1
                    )?.ts;
                    const t2 = $window._appStateChanges.find(item => item.to == 'loading')?.ts;
                    // count until first of loading or meeting-active.
                    if ((t2 || t1) && t0) {
                        const waitTime = (t2 || t1) - t0;
                        if (waitTime > 1000) {
                            // ignore if no real wait happened.
                            data.waitTime = waitTime;
                        }
                    }
                    logger.log(
                        'initConnectivity',
                        'wait time ' + data.waitTime + ' state changes=' + JSON.stringify($window._appStateChanges)
                    );
                }
                data.startTime = !data.appStart ? data.modInit : data.appStart + (data.waitTime || 0);
            }
        }

        // check if we are disconnected from Internet by checking Ajax to our media server as well as external third-party web server.
        // if timeout is supplied in milliseconds, that is used. otherwise defaults to 10s.
        // callback if supplied is invoked with connectivity status (true or false).
        function checkConnectivity(reason, timeout, callback) {
            // allow reentrant call, store callbacks, and invoke them when done.
            if (callback) {
                self.checkConn.callbacks.push(callback);
            }
            var invokeCallback = function (value) {
                var callbacks = self.checkConn.callbacks.splice(0, self.checkConn.callbacks.length);
                callbacks.forEach(function (callback) {
                    callback(value);
                });
            };

            if (!self.checkConn.timer && !self.checkConn.xhr1 && !self.checkConn.xhr2) {
                logger.log('checkConnectivity', 'check connectivity scheduled because of', reason);

                // timer used to avoid interrupting or delaying the caller callback function
                self.checkConn.timer = $timeout(function () {
                    var serverHost = phoneConferenceService.getPhoneData().server;

                    self.checkConn.start1 = self.checkConn.start2 = Date.now();
                    self.checkConn.end1 = self.checkConn.end2 = 0;
                    self.checkConn.status1 = self.checkConn.status2 = null;

                    self.checkConn.timer = $timeout(function () {
                        self.checkConn.timer = null;
                        self.logCheckConnectivityResult(serverHost, 'timeout', reason);
                        self.stopCheckConnectivity(true); // abort pending
                        invokeCallback(false);
                    }, timeout || self.checkConn.timeout); // limit to 10 seconds for connectivity check

                    var handler = function () {
                        if (self.checkConn.status1 && self.checkConn.status2) {
                            if (self.checkConn.timer) {
                                $timeout.cancel(self.checkConn.timer);
                                self.checkConn.timer = null;
                            }
                            self.logCheckConnectivityResult(serverHost, undefined, reason);
                            invokeCallback(true);
                        }
                    };

                    var xhr1 = (self.checkConn.xhr1 = new XMLHttpRequest());
                    xhr1.onload = xhr1.onerror = function (event) {
                        if (self.checkConn.xhr1) {
                            self.checkConn.status1 = event.type;
                            self.checkConn.end1 = Date.now();
                            self.checkConn.xhr1 = null;
                            handler();
                        }
                    };
                    var uploadUrl = 'https://' + serverHost + '/speedtest.bin?n=' + ('' + Math.random()).substr(2, 20);
                    xhr1.open('POST', uploadUrl);
                    xhr1.withCredentials = true;
                    xhr1.send('check');

                    var xhr2 = (self.checkConn.xhr2 = new XMLHttpRequest());
                    xhr2.onload = xhr2.onerror = function (event) {
                        if (self.checkConn.xhr2) {
                            self.checkConn.status2 = event.type;
                            self.checkConn.end2 = Date.now();
                            self.checkConn.xhr2 = null;
                            handler();
                        }
                    };
                    // this will always fail, but from server.
                    var extUrl = 'https://www.google.com/?r=' + ('' + Math.random()).substr(2, 10);
                    xhr2.open('GET', extUrl);
                    xhr2.send();
                }, 0);
            } else {
                logService.log('videoroomCtrl checkConnectivity not scheduled');
            }
        }

        function stopCheckConnectivity(keepCallbacks) {
            if (self.checkConn.timer) {
                $timeout.cancel(self.checkConn.timer);
                self.checkConn.timer = null;
            }
            if (self.checkConn.xhr1) {
                var xhr1 = self.checkConn.xhr1;
                self.checkConn.xhr1 = null;
                xhr1.abort();
            }
            if (self.checkConn.xhr2) {
                var xhr2 = self.checkConn.xhr2;
                self.checkConn.xhr2 = null;
                xhr2.abort();
            }
            if (!keepCallbacks && self.checkConn.callbacks.length > 0) {
                self.checkConn.callbacks.splice(0, self.checkConn.callbacks.length);
            }
        }

        function logCheckConnectivityResult(server, type, reason) {
            var time1 = (self.checkConn.end1 || undefined) - self.checkConn.start1;
            var time2 = (self.checkConn.end2 || undefined) - self.checkConn.start2;

            logger.log(
                'logCheckConnectivityResult',
                `checkConnectivity ${type || 'completed'} result=${self.checkConn.status1}/${
                    self.checkConn.status2
                } time=${time1}/${time2} reason=${reason}`
            );

            var value1 = {
                status1: self.checkConn.status1 || '0',
                status2: self.checkConn.status2 || '0',
                time1: isNaN(time1) ? 'NaN' : time1,
                time2: isNaN(time2) ? 'NaN' : time2,
                reason: reason
            };
            self.msgflowEvent('connectivity ' + (type || 'check'), value1);

            if (
                reason !== 'networkCollectMoreStatsAfter' ||
                type === 'timeout' ||
                Math.max(time1, time2) > self.networkState.moreStats.connectivityDelayThreshold
            ) {
                // need copy of value1 since analytics modifies its attributes.
                var value2 = Object.assign({ sfuEvent: true, server: (server || '').split('.')[0] }, value1);
                analyticsWrapperService.eventTrack(
                    'Meeting - connectivity ' +
                        (type || 'check') +
                        ' - ' +
                        (isNaN(time2) ? 'failed internet' : isNaN(time1) ? 'failed server' : 'success'),
                    value2
                );
            }
        }

        function updateConnTimeDevice() {
            const active =
                !connectivityService.getAudioThroughPhone() &&
                !avDeviceService.isAudioDisconnected() &&
                avDeviceService.hasMicrophone() &&
                avDeviceService.getDevicePermissions().audioAllowed;
            self.updateConnTimeData('audioInput', active);
        }

        function updateConnTimeData(name, extra) {
            const data = self.connTimeData;
            if (!data.enabled && name != 'joinFlow' && name != 'audioInput') {
                return;
            }

            const now = Date.now();

            if (name == 'joinFlow' || name == 'screenSelect' || (name == 'audioInput' && !data.enabled)) {
                data[name] = extra;
                data.events.push({ name, value: true, ts: now - extra }, { name, value: false, ts: now });
                if (!data.enabled) {
                    return;
                }
            } else {
                if (name in data) {
                    const old = data[name]; // may be undefined, false or true
                    if (old !== extra) {
                        data[name] = extra;
                        data.events.push({ name, value: extra, ts: now });
                    } else {
                        // no change
                        return;
                    }
                }
                // reset some state
                if (!extra) {
                    if (name == 'screenPublish') {
                        data.screenMedia = data.screenConnect = data.screenIce = false; // will set again
                    } else if (name == 'videoPublish') {
                        data.videoMedia = data.videoConnect = data.videoIce = false; // will set again
                    }
                } else {
                    if (name == 'videoButton') {
                        data.videoStart = now;
                        data.videoSetup = undefined;
                    } else if (name == 'screenButton') {
                        data.screenStart = now;
                        data.screenSetup = undefined;
                        data.screenSelect = undefined;
                    }
                }
            }

            const connected =
                data.network &&
                data.nodeSocket &&
                data.mediaSocket &&
                (!data.audioInput || (data.fsConnect && data.voiceCallMedia)) &&
                data.voiceCallConnect &&
                data.voiceCallIce &&
                (!data.videoButton ||
                    !data.videoSetup ||
                    (data.videoPublish && data.videoConnect && data.videoMedia && data.videoIce)) &&
                (!data.screenButton ||
                    !data.screenSetup ||
                    (data.screenPublish && data.screenConnect && data.screenMedia && data.screenIce));

            let clear = false;

            if (data.callSetup && data.mediaSocket && extra && name == 'mediaSocket') {
                data.reason = data.reason ? data.reason + ',media' : 'media';
            }

            if (data.callSetup && data.nodeSocket && extra && name == 'nodeSocket') {
                data.reason = data.reason ? data.reason + ',node' : 'node';
            }

            if (!data.connect && connected) {
                data.connect = now;
                if (data.disconnect) {
                    data.count = (data.count || 0) + 1;
                    const duration = data.connect - data.disconnect;
                    data.disconnectDuration = (data.disconnectDuration || 0) + duration;

                    const events = data.events
                        .filter(item => item.name != 'connect')
                        .map(item => {
                            return {
                                name: item.name,
                                value: item.value,
                                ts: item.ts - data.disconnect
                            };
                        })
                        .map(item => {
                            return `${item.ts} - ${item.value ? 'on ' : 'off'} ${item.name}`;
                        });

                    logger.log('updateConnTimeData', 'reconnected in ' + duration + ' ms');

                    if (!data.stats) {
                        data.stats = {};
                    }
                    data.stats.disconnectActivity = Math.round(duration / 1000); // seconds
                    // const total = now - data.startTime - data.callSetup;
                    data.stats.disconnectDuration = Math.round(data.disconnectDuration / 1000);
                    // if (total > 0) {
                    //     data.stats.disconnectPercent = Math.round(data.disconnectDuration * 100000/ total) / 1000; // avoid too fine grained
                    // }
                    data.stats.disconnectCount = data.count;
                    if (data.reason) {
                        data.stats.disconnectReason = data.reason;
                        data.reason = undefined;
                    }

                    self.msgflowEvent('reconnected:' + Math.round(duration / 100) / 10, {
                        start: new Date(data.disconnect).toISOString(),
                        end: new Date(data.connect).toISOString(),
                        duration,
                        events
                    });
                }
                data.disconnect = undefined;
                data.events.push({ name: 'connect', value: true, ts: now });

                clear = true;
            }

            if (data.connect && !connected) {
                data.disconnect = now;
                data.connect = undefined;

                const last = data.events.pop();
                data.events = data.events.filter(item => item.name == 'connect');
                data.events.push(last);
                data.events.push({ name: 'connect', value: false, ts: now });
            }

            if (!data.callSetup && data.connect) {
                // calculate if needed
                const startTime = data.appStart || data.modInit;
                data.callSetup = now - data.startTime - (data.joinFlow || 0);
                logger.log('updateConnTimeData', 'call setup in ' + data.callSetup + ' ms');

                const events = data.events
                    .filter(item => item.name != 'connect')
                    .map(item => {
                        return { name: item.name, value: item.value, ts: item.ts - startTime };
                    })
                    .map(item => {
                        return `${('' + item.ts).padStart(4, ' ')} - ${item.value ? 'on ' : 'off'} ${item.name}`;
                    });

                if (!data.stats) {
                    data.stats = {};
                }
                data.stats.callSetupDelay = Math.round(data.callSetup / 1000); // seconds
                if (data.joinFlow) {
                    data.stats.joinFlowWait = Math.round(data.joinFlow / 1000);
                }

                self.msgflowEvent('call-setup:' + Math.round(data.callSetup / 100) / 10, {
                    startTime: new Date(startTime).toISOString(),
                    duration: data.callSetup,
                    waitTime: data.waitTime,
                    joinFlow: data.joinFlow,
                    events
                });
            }

            if (data.videoButton && !data.videoSetup) {
                const videoActive = data.videoPublish && data.videoConnect && data.videoMedia && data.videoIce;
                if (videoActive) {
                    const startTime = data.videoStart;
                    data.videoSetup = now - startTime; // TODO: remove time for permissions
                    logger.log('updateConnTimeData', 'video setup in ' + data.videoSetup + ' ms');

                    const events = data.events
                        .filter(item => item.name != 'connect')
                        .map(item => {
                            return { name: item.name, value: item.value, ts: item.ts - startTime };
                        })
                        .map(item => {
                            return `${('' + item.ts).padStart(4, ' ')} - ${item.value ? 'on ' : 'off'} ${item.name}`;
                        });

                    if (!data.stats) {
                        data.stats = {};
                    }
                    data.stats.videoSetupDelay = Math.round(data.videoSetup / 1000);

                    self.msgflowEvent('video-setup:' + Math.round(data.videoSetup / 100) / 10, {
                        startTime: new Date(data.videoStart).toISOString(),
                        duration: data.videoSetup,
                        events
                    });

                    data.events = data.events.filter(item => {
                        return !item.name.startsWith('video');
                    });
                }
            }

            if (data.screenButton && !data.screenSetup) {
                const screenActive = data.screenPublish && data.screenConnect && data.screenMedia && data.screenIce;
                if (screenActive) {
                    const startTime = data.screenStart;
                    data.screenSetup = now - startTime - (data.screenSelect || 0);
                    logger.log('updateConnTimeData', 'screen setup in ' + data.screenSetup + ' ms');

                    const events = data.events
                        .filter(item => item.name != 'connect')
                        .map(item => {
                            return { name: item.name, value: item.value, ts: item.ts - startTime };
                        })
                        .map(item => {
                            return `${('' + item.ts).padStart(4, ' ')} - ${item.value ? 'on ' : 'off'} ${item.name}`;
                        });

                    if (!data.stats) {
                        data.stats = {};
                    }
                    data.stats.screenSetupDelay = Math.round(data.screenSetup / 1000);
                    if (data.screenSelect) {
                        data.stats.screenSelectWait = Math.round(data.screenSelect / 1000);
                    }

                    self.msgflowEvent('screen-setup:' + Math.round(data.screenSetup / 100) / 10, {
                        startTime: new Date(data.screenStart).toISOString(),
                        duration: data.screenSetup,
                        selection: data.screenSelect,
                        events
                    });

                    data.events = data.events.filter(item => {
                        return !item.name.startsWith('screen');
                    });
                }
            }

            // remove events no longer needed
            if (!extra) {
                if (name == 'videoButton') {
                    data.events = data.events.filter(item => {
                        return !item.name.startsWith('video');
                    });
                } else if (name == 'screenButton') {
                    data.events = data.events.filter(item => {
                        return !item.name.startsWith('screen');
                    });
                }
            }

            if (clear) {
                data.events = data.events.filter(item => item.name == 'connect');
            }
        }

        function addConnectivityMetric(reports) {
            const data = self.connTimeData;
            if (!data.enabled) {
                return reports;
            }

            if (data.stats) {
                // TODO: this can be avoided by doing "reports instanceof Array" on electron
                let newReports = [];
                reports.forEach(item => {
                    newReports.push(item);
                });
                if (newReports.length > 0) {
                    const oneReport = {
                        id: 'Connectivity',
                        type: 'connectivity',
                        timestamp: newReports[0].timestamp
                    };
                    newReports.push(Object.assign(oneReport, data.stats));

                    let valid = false;
                    for (let attr in data.stats) {
                        if (data.stats[attr] && typeof data.stats[attr] === 'number') {
                            valid = true;
                            data.stats[attr] = 0; // reset to 0 for next time
                        }
                    }
                    if (!valid) {
                        // no need to send anymore
                        data.stats = null;
                    }
                    return newReports;
                }
            }
            return reports;
        }
    }
]);
